import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  EventsMonitorCountResponse,
  EventsMonitorTrendsResponse,
  EventsMonitorEventGroupResponse,
  EventsMonitorResponse,
  EventsMonitorSeveritiesResponse,
  EventsMonitorTrendsPayload,
  EventsMonitorPayload,
  EventsMonitorDurationGroupResponse
} from '../events-monitor.types';
import { DevicesPayload } from '../../../equipment/devices/components/devices.models';
import { LOADER_CONTEXT } from '../../../../services/interceptors/loader.interceptor';
import {
  MapAreaDevicesApiRequestBody,
  MapAreaDevicesApiResponse
} from 'src/app/pages/administration/report-groups/report-groups.types';

@Injectable({ providedIn: 'root' })
export class EventsMonitorApiService {
  private http = inject(HttpClient);

  getAll(payload: DevicesPayload): Observable<EventsMonitorResponse> {
    return this.http.post<EventsMonitorResponse>(`/api/events`, payload, {
      context: new HttpContext().set(LOADER_CONTEXT, true)
    });
  }

  getWidgetTotalCount(payload: Pick<EventsMonitorPayload, 'filters'>): Observable<EventsMonitorCountResponse> {
    return this.http.post<EventsMonitorCountResponse>(`/api/events/count`, payload);
  }

  getWidgetSeverity(payload: Pick<EventsMonitorPayload, 'filters'>): Observable<EventsMonitorSeveritiesResponse[]> {
    return this.http.post<EventsMonitorSeveritiesResponse[]>(`/api/events/aggregated-severities`, payload);
  }

  getWidgetEventGroup(payload: Pick<EventsMonitorPayload, 'filters'>): Observable<EventsMonitorEventGroupResponse[]> {
    return this.http.post<EventsMonitorEventGroupResponse[]>(`/api/events/aggregated-groups`, payload);
  }

  getWidgetDurationGroup(
    payload: Pick<EventsMonitorPayload, 'filters'>
  ): Observable<EventsMonitorDurationGroupResponse[]> {
    return this.http.post<EventsMonitorDurationGroupResponse[]>(`/api/events/duration`, payload);
  }

  getTrends(payload: EventsMonitorTrendsPayload): Observable<EventsMonitorTrendsResponse> {
    return this.http.post<EventsMonitorTrendsResponse>(`/api/events/trends`, payload);
  }

  getMapAreaDevicesFromEvents(payload: MapAreaDevicesApiRequestBody): Observable<MapAreaDevicesApiResponse> {
    return this.http.post<MapAreaDevicesApiResponse>('/api/map/area/devices-from-events', payload);
  }
}
